const interfaceTranslations = {
  selectedCountryAriaLabel: "Valgt land",
  noCountrySelected: "Intet land er valgt",
  countryListAriaLabel: "Liste over lande",
  searchPlaceholder: "Søg",
  zeroSearchResults: "Ingen resultater fundet",
  oneSearchResult: "1 resultat fundet",
  multipleSearchResults: "${count} resultater fundet",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
};
export default interfaceTranslations;
